/** Canonical display labels for API wallet type keys (lowercase). */
const WALLET_TYPE_LABELS = {
  main: "Main",
  spot: "Spot",
  p2p: "P2P",
  futures: "Futures",
  swap: "Swap",
  earning: "Earning",
  margin: "Isolated Margin",
  cross_margin: "Cross Margin",
  options: "Options",
};

/**
 * @param {string|null|undefined} key
 * @returns {string} e.g. "P2P", or title-cased fallback for unknown keys
 */
export function getWalletTypeLabel(key) {
  if (key == null || key === "") return "";
  const k = String(key).trim().toLowerCase();
  if (WALLET_TYPE_LABELS[k]) return WALLET_TYPE_LABELS[k];
  const s = String(key).trim();
  if (!s) return "";
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/**
 * Page heading: "Main Wallet", "P2P Wallet" (same pattern as previous capitalizeWallet).
 * @param {string|null|undefined} key
 */
export function getWalletPageLabel(key) {
  if (key == null || String(key).trim() === "") return "Wallet";
  const label = getWalletTypeLabel(key);
  return label ? `${label} Wallet` : "Wallet";
}
